var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { KeywordSearchRepository } from '../repositories/keyword-search.repository.interface';
let KeywordSearchServiceImpl = class KeywordSearchServiceImpl {
    constructor(_keywordSearchRepository) {
        this._keywordSearchRepository = _keywordSearchRepository;
    }
    getKeywordSuggest(keyword) {
        return this._keywordSearchRepository.getKeywordSuggest(keyword);
    }
};
KeywordSearchServiceImpl = __decorate([
    injectable(),
    __param(0, inject(KeywordSearchRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof KeywordSearchRepository !== "undefined" && KeywordSearchRepository) === "function" ? _a : Object])
], KeywordSearchServiceImpl);
export { KeywordSearchServiceImpl };
